(function () {
  /* globals console */
  'use strict';

  /* Directives */
  angular.module('wsLrs.directives').
  /* onSelect should be a function defined by the parent scope for what should happen when item is selected
   * hidePeople is a boolean to determine if people are included alongside groups in the results
   * allOption is a boolean to determine if "All" is included as an option to select. Will have an id of -1
   * searchPlaceholder is the placeholder text that will display in the typeahead
   * limit should be an integer specifying the max number of results to display*/

  directive('wsPeopleGroupsSearch', ['$http', '$q', '$rootScope', 'Api', 'Demo', 'GroupUtils', 'screenSize', 'User', 'UserRoles', 'Utils', '$uibModal', 'QuickFilters', function wsPeopleGroupsSearch($http, $q, $rootScope, Api, Demo, GroupUtils, screenSize, User, UserRoles, Utils, $uibModal, QuickFilters) {
    return {
      scope: {
        query: '=?',
        onSelect: "=",
        onRemove: "=?",
        clearSelection: "=?",
        preserveInputTextOnSelect: "=?",
        hidePeople: "=?",
        includeWatershedEmployees: "=?",
        hideGroups: "=?",
        hideGroupTypes: "<?",
        // { boolean } Should we hide groupTypes from the results
        hidePersonId: "=?",
        hideGroupId: "=?",
        hideSelections: "=?",
        groupsByCustomId: "=?",
        groupTypeName: "=?",
        multiSelect: "=?",
        allOption: "=?",
        searchPlaceholder: "=?",
        limit: "=?",
        size: "@",
        columnWidth: "@",
        block: "@",
        selectOnExact: '=?',
        editable: '=?',
        selectedEntitiesHeader: '=?',
        expandedPermissionsIfAllowed: '=?',
        excludeEntities: "<?",
        triggerOpen: "=?",
        referenceType: "<",
        referenceId: "<"
      },
      templateUrl: "modules/common/directives/people-and-groups-search/people-and-groups-search.html",
      require: "ngModel",
      link: function link($scope, el, attrs, ngModel) {
        // If we init in a session with an org, we can go figure out the groups
        var session = User.get();
        if (session && session.organization) {
          initPlaceholder();
        }

        //provide default values if not specified in directive instance
        $scope.limit = $scope.limit || 10;
        $scope.hidePeople = typeof $scope.hidePeople === 'undefined' ? false : $scope.hidePeople;
        $scope.hideGroups = typeof $scope.hideGroups === 'undefined' ? false : $scope.hideGroups;
        $scope.hideGroupTypes = typeof $scope.hideGroupTypes === 'undefined' ? false : $scope.hideGroupTypes;
        $scope.hideSelections = typeof $scope.hideSelections === 'undefined' ? false : $scope.hideSelections;
        $scope.includeWatershedEmployees = UserRoles.isSystemAdmin(session);
        $scope.groupsByCustomId = typeof $scope.groupsByCustomId === 'undefined' ? true : $scope.groupsByCustomId;
        $scope.multiSelect = typeof $scope.multiSelect === 'undefined' ? false : $scope.multiSelect;
        $scope.allOption = typeof $scope.allOption === 'undefined' ? false : $scope.allOption;
        $scope.selectOnExact = typeof $scope.selectOnExact === 'undefined' ? false : $scope.selectOnExact;
        $scope.editable = typeof $scope.editable === 'undefined' ? true : $scope.editable;
        $scope.columnWidth = $scope.columnWidth || 'col-xs-12';
        $scope.expandedPermissionsIfAllowed = !!$scope.expandedPermissionsIfAllowed;
        $scope.selectBehavior = function () {
          if (!attrs.noClearOnSelect) {
            $scope.searchTerm = '';
          }
        };
        $scope.onBlur = function () {
          $scope.searchTerm = '';
        };
        function initPlaceholder() {
          GroupUtils.getGroupCount().then(function (groupCount) {
            var hasGroups = groupCount > 0;
            $scope.searchPlaceholder = $scope.searchPlaceholder || ($scope.hidePeople ? "Search for a group" : $scope.hideGroups || !hasGroups ? "Search for a person" : "Search for a person or group");
          });
        }

        // When the org switches, we need to go figure out the groups
        var removeOrgSelectedListener = $rootScope.$on("organization-selected", function () {
          initPlaceholder();
        });
        $scope.$on("$destroy", removeOrgSelectedListener);
        if (screenSize.is('xs')) {
          $scope.limit = 6;
          $scope.searchPlaceholder = "Search";
        }
        $scope.clearSelection = function () {
          $scope.searchTerm = '';
        };
        $scope.searchCall = null;
        $scope.typeahead = function (query) {
          $scope.query = query;
          delete $scope.error;
          var excludedPeopleIds = [],
            excludedGroupIds = [];
          _.each(_.flatten($scope.excludeEntities), function (e) {
            if (e.personas) {
              excludedPeopleIds.push(e.id);
            } else if (e.id) {
              excludedGroupIds.push(e.id);
            }
          });
          if ($scope.searchCall) {
            $scope.searchCall.cancel();
          }

          // Make this an IIFE so that we have immediate access to the object it returns.
          $scope.searchCall = function () {
            var canceller = $q.defer();
            var bodyData = {
              "query": query,
              "hidePeople": $scope.hidePeople,
              "hideGroups": $scope.hideGroups,
              "hideGroupTypes": $scope.hideGroupTypes,
              "includeWSEmployees": $scope.includeWatershedEmployees,
              "includeAllGroup": $scope.allOption,
              "expandedPermissionsIfAllowed": $scope.expandedPermissionsIfAllowed
            };
            if (excludedGroupIds.length) {
              bodyData.excludedGroupIds = excludedGroupIds;
            }
            if (excludedPeopleIds.length) {
              bodyData.excludedPeopleIds = excludedPeopleIds;
            }
            var sortParam = QuickFilters.getQuickFilterSortParam($scope.referenceType, $scope.referenceId, {
              itemName: 'people'
            }, "name");
            var requestConfiguration = {
              method: 'POST',
              url: Api.url("/search/people-and-groups", false, true),
              data: bodyData,
              params: {
                "order_by": sortParam,
                "_limit": $scope.tempLimit || $scope.limit,
                "demo": Demo.isDemoMode()
              },
              timeout: canceller.promise
            };
            if ($scope.referenceType) {
              requestConfiguration.params[$scope.referenceType] = $scope.referenceId;
            }
            var promise = $http(requestConfiguration).catch(function () {
              /* Promise was canceled */
            });
            var cancel = function cancel() {
              return canceller.resolve("New request made");
            };
            return {
              promise: promise,
              cancel: cancel
            };
          }();
          var totalMatches = 0;
          return $scope.searchCall.promise.then(function (results) {
            var people = Utils._try(function () {
                return results.data.people.results;
              }, []),
              groups = Utils._try(function () {
                return results.data.groups.results;
              }, []);
            totalMatches = Utils._try(function () {
              return results.data.people.count;
            }, 0) + Utils._try(function () {
              return results.data.groups.count;
            }, 0);
            if ($scope.hideGroupId) {
              totalMatches -= groups.length;
              groups = _.reject(groups, function (g) {
                return g.id === $scope.hideGroupId;
              });
              totalMatches += groups.length;
            }
            if (people.length) {
              people[0].groupType = "People";
              if ($scope.hidePersonId) {
                if (!_.isArray($scope.hidePersonId)) {
                  $scope.hidePersonId = [$scope.hidePersonId];
                }
                totalMatches -= people.length;
                people = _.reject(people, function (p) {
                  return _.contains($scope.hidePersonId, p.id);
                });
                totalMatches += people.length;
              }
            }

            // group/sort items by displayOrder if set, else by name
            var displayOrder = false;
            var grouped = _.chain(groups).groupBy(function (item) {
              return item.type ? item.type.id : 0;
            }).map(function (groups) {
              if (groups.length) {
                var groupType = groups[0].type;
                if (!displayOrder && groupType && groupType.displayOrder !== 0) {
                  displayOrder = true;
                }
              }
              return {
                type: groups.length ? groups[0].type : null,
                groups: groups
              };
            }).sortBy(function (item) {
              if (item.type) {
                if (displayOrder) {
                  return item.type.displayOrder;
                } else if (typeof item.type.name === "string") {
                  return item.type.name.toLowerCase();
                }
              }
              return 0;
            }).value();

            // sort each section by name, decorate with groupType, and limit results
            var groupResults = _.reduce(grouped, function (results, section) {
              var sorted = _.sortBy(section.groups, "name");
              var type = sorted[0].type;
              sorted[0].groupType = type ? type.name || "Groups" : "Groups";
              if (sorted[0].groupType === "Alls") {
                sorted[0].groupType = "All";
              }
              return results.concat(sorted);
            }, []);

            // If multi-select, don't let already-selected options show up in this list
            if ($scope.multiSelect) {
              var groupedSelectedEntities = _.groupBy($scope.selectedEntities, function (x) {
                return _.has(x, 'personas');
              });
              groupResults = _.filter(groupResults, function (x) {
                return !_.findWhere(groupedSelectedEntities[false], {
                  id: x.id
                });
              });
              people = _.filter(people, function (x) {
                return !_.findWhere(groupedSelectedEntities[true], {
                  id: x.id
                });
              });
            }

            // limited the grouped & sorted groups, then concat with limited people
            var limitedResults = _.first(groupResults, $scope.tempLimit || $scope.limit).concat(_.first(people, $scope.tempLimit || $scope.limit));
            if ($scope.multiSelect) {
              totalMatches -= $scope.selectedEntities.length;
            }
            var additionalResults = totalMatches - limitedResults.length;
            if (additionalResults > 0 && !$scope.tempLimit) {
              limitedResults.push({
                name: 'View all ' + totalMatches + ' results',
                showMore: true,
                count: additionalResults
              });
            }
            $scope.isLoading = false;
            return limitedResults;
          }, function err(e) {
            $scope.isLoading = false;
            console.error(e);
            $scope.error = "There was an error during the search";
          });
        };
        function openMoreModal(term) {
          $scope.modalSearchTerm = term;
          $scope.listerModalInstance = $uibModal.open({
            controller: "moreController",
            templateUrl: 'modules/common/directives/people-and-groups-search/people-and-groups-more-modal.html',
            backdrop: 'static',
            size: 'lg',
            scope: $scope
          });
        }

        // For multi-select
        if ($scope.multiSelect) {
          $scope.removeSelection = function removeSelection(entityToRemove) {
            var typeToRemove = _.has(entityToRemove, 'personas');
            $scope.selectedEntities = _.reject($scope.selectedEntities, function (x) {
              return _.has(x, 'personas') === typeToRemove && x.id === entityToRemove.id;
            });
            if ($scope.onRemove) {
              $scope.onRemove(entityToRemove, $scope.selectedEntities);
            }
          };
          $scope.addSelection = function addSelection(entity) {
            if (entity.showMore) {
              $scope.excludeEntities = $scope.selectedEntities;
              openMoreModal(entity.query);
              return;
            }
            $scope.selectedEntities.push(entity);
            $scope.searchTerm = '';
            ngModel.$setViewValue($scope.selectedEntities);
            if ($scope.onSelect) {
              $scope.onSelect(entity, $scope.selectedEntities);
            }
          };
          ngModel.$render = function () {
            $scope.selectedEntities = ngModel.$viewValue;
          };
        } else {
          $scope.addSelection = function addSelection(entity) {
            if (entity.showMore) {
              ngModel.$setViewValue(entity.query);
              openMoreModal(entity.query);
              return;
            }
            delete $scope.tempLimit;
            ngModel.$setViewValue(entity);
            if ($scope.onSelect) {
              $scope.onSelect(entity);
            }
          };
        }
      }
    };
  }]).controller('moreController', ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
    $scope.select = function (entity) {
      $scope.onSelect(entity);
      if ($scope.preserveInputTextOnSelect) {
        $scope.modalSearchTerm = entity.name;
      } else {
        $scope.modalSearchTerm = '';
      }
      $uibModalInstance.close();
    };
    $scope.close = function () {
      $scope.modalSearchTerm = '';
      $uibModalInstance.close();
    };
  }]);
})();
